var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

/**
 * This is the widget's editor. This is what shows up on the left side
 * of the screen in the demo. Only the question writer sees this.
 */
var ExampleWidgetEditor = React.createClass({
    displayName: "ExampleWidgetEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            correct: ""
        };
    },

    handleAnswerChange: function handleAnswerChange(event) {
        this.change({
            correct: event.target.value
        });
    },

    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "label",
                null,
                "Correct answer:",
                React.createElement("input", {
                    value: this.props.correct,
                    onChange: this.handleAnswerChange,
                    ref: "input"
                })
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    focus: function focus() {
        this.refs.input.focus();
        return true;
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = ExampleWidgetEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/example-widget-editor.jsx
 ** module id = 161
 ** module chunks = 0 1
 **/